import styled from 'styled-components';
import { media } from '../../../../../../../theme/shared/breakpoints';
import { Link } from '../../../../../../components/Link/Link';
import { Gray, Shade } from '../../../../../../constants/styles';
import { LinksList } from '../LinksList/LinksList';
export const Container = styled.div `
  display: grid;
  grid-column-gap: 30px;
  grid-template-columns: 1.2fr 1.2fr 1.2fr 1.2fr 0.5fr;
  margin-left: auto;
  margin-right: auto;
  max-height: 455px;
  max-width: 1270px;
  min-height: 285px;
  padding: 40px 20px;
`;
export const Column = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledLinksList = styled(LinksList) `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 25px;
  list-style: none;
  font-weight: 300;
`;
export const ImagesContainer = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 28px;
  position: relative;

  ${media.xLarge} {
    flex-direction: row;
  }
`;
export const ColumnDivider = styled.div `
  background-color: ${Gray.x200};
  bottom: 50%;
  height: 156px;
  position: absolute;
  right: -12px;
  width: 1px;
  transform: translate(0, 50%);
`;
export const StyledImageLink = styled(Link) `
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  box-shadow: ${Shade.x500};
  justify-content: center;
  margin: 15px 5px;
  max-width: 245px;
  padding: 2px;
  text-decoration: none;
  line-height: 1;

  &:hover {
    text-decoration: underline;
  }
`;
export const ImageTitle = styled.span `
  display: block;
  padding: 7px 0 7px 7px;
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  font-weight: 300;
`;
export const AllCollectionsLinkWrapper = styled(Column) `
  justify-content: center;
`;
export const AllCollectionsLink = styled(Link) `
  color: ${({ theme }) => theme.colorsV2.font.textLink};
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  font-weight: 600;
  line-height: 24px;
  margin-top: 24px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:visited {
    color: ${({ theme }) => theme.colorsV2.font.textLink};
  }
`;
//# sourceMappingURL=BrowseCollectionsPanel.styled.js.map